// Custom Language Dropdown Handler
if (typeof window.CustomDropdown === 'undefined') {
  window.CustomDropdown = class CustomDropdown {
  constructor(container) {
    this.container = container;
    this.trigger = container.querySelector('[data-dropdown-trigger]');
    this.list = container.querySelector('[data-dropdown-list]');
    this.options = container.querySelectorAll('[data-dropdown-option]');
    this.selectedText = container.querySelector('[data-dropdown-selected]');
    this.hiddenSelect = container.closest('.language-selector').querySelector('.localization-form__select--hidden');
    this.dropdown = container.querySelector('.custom-dropdown');

    this.init();
  }

  init() {
    // Validate required elements exist
    if (!this.trigger || !this.list) {
      console.warn('CustomDropdown: Required elements not found');
      return;
    }

    // Toggle dropdown on trigger click
    this.trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggle();
    });

    // Handle option selection
    this.options.forEach(option => {
      option.addEventListener('click', (e) => {
        e.stopPropagation();
        this.selectOption(option);
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!this.container.contains(e.target)) {
        this.close();
      }
    });

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.list && !this.list.hidden) {
        this.close();
      }
    });
  }

  toggle() {
    if (!this.list) return;

    if (this.list.hidden) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    if (!this.list) return;

    this.list.hidden = false;
    if (this.dropdown) {
      this.dropdown.classList.add('is-open');
    }
  }

  close() {
    if (!this.list) return;

    this.list.hidden = true;
    if (this.dropdown) {
      this.dropdown.classList.remove('is-open');
    }
  }

  selectOption(option) {
    const value = option.dataset.value;
    const label = option.dataset.label;

    // Update visual selected text
    if (this.selectedText) {
      this.selectedText.textContent = label;
    }

    // Update active state
    this.options.forEach(opt => opt.classList.remove('custom-dropdown__option--active'));
    option.classList.add('custom-dropdown__option--active');

    // Update hidden select and trigger change
    if (this.hiddenSelect) {
      this.hiddenSelect.value = value;

      // Trigger change event to submit form
      const changeEvent = new Event('change', { bubbles: true });
      this.hiddenSelect.dispatchEvent(changeEvent);
    }

    // Close dropdown
    this.close();
  }
  };
}

// Initialize all custom dropdowns (only once)
if (!window.customDropdownInitialized) {
  window.customDropdownInitialized = true;

  document.addEventListener('DOMContentLoaded', () => {
    const dropdownContainers = document.querySelectorAll('[data-custom-dropdown]');

    dropdownContainers.forEach(container => {
      const customDropdownElement = container.querySelector('.custom-dropdown');
      if (customDropdownElement && !customDropdownElement.dataset.initialized) {
        customDropdownElement.dataset.initialized = 'true';
        new window.CustomDropdown(customDropdownElement);
      }
    });
  });
}

// Reinitialize on dynamic content load (for Shopify sections)
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    const dropdownContainers = document.querySelectorAll('[data-custom-dropdown]');

    dropdownContainers.forEach(container => {
      const customDropdownElement = container.querySelector('.custom-dropdown');
      if (customDropdownElement && !customDropdownElement.dataset.initialized) {
        customDropdownElement.dataset.initialized = 'true';
        new window.CustomDropdown(customDropdownElement);
      }
    });
  });
}
